import { ShieldCheck } from '@liveauctioneers/hammer-ui-core/icons';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary, H1 } from '@liveauctioneers/hammer-ui-core/text';

export const PurchaseProtectionHero = () => {
    const { formatMessage } = useIntl();
    return (
        <div className="flex flex-col items-center justify-center gap-xs px-md py-[96px] text-center xsMax:px-sm xsMax:py-2xl">
            <div className="flex items-center gap-xs xsMax:flex-col">
                <ShieldCheck
                    className="fill-surface-900"
                    style="fill"
                />
                <H1>{formatMessage({ id: 'purchaseProtectionPage.hero.title' })}</H1>
            </div>
            <BodyPrimary>{formatMessage({ id: 'purchaseProtectionPage.hero.description' })}</BodyPrimary>
        </div>
    );
};
